module.exports = "pegasus_template/assets/theme3/facebook-icon.png";